export default __webpack_public_path__ + "static/media/optimization.f8fe26a7.png";